//import axios from "axios"
import { useState } from "react"
//import { useLogin } from "../hooks/useLogin"
import React from "react"
import {VisDiv} from "../"
import axios from "axios"
import { useAuthContext } from "../../hooks/useAuthContext"
import { useStateContext } from "../../context/StateContext"
import { Token } from "aws-sdk"

// Create axios instance with default config
const axiosInstance = axios.create({
  timeout: 15000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

const LoginForm = ({ database, User, otpEnabled, buttonClassName, hideTitle, transparentBackground, labels = {email: 'Email Address', password: 'Password',}}) => {
  const [emailExists, setEmailExists] = useState({status:"CHECKING"})
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loginError, setLoginError] = useState(undefined)  
  const [otpSent, setOtpSent] = useState(false) 
  const [otp, setOtp] = useState('')
  const { dispatch, user } = useAuthContext()
  const {setSUser, setCustomer, apiUrl} = useStateContext()
  
const emailExistsFn = async (email, database) => {
  const request = async (req, res) => {
    try {
      if (!email) {
        setLoginError("Please enter an email address");
        return;
      }

      console.log("Checking email at:", `${apiUrl}/users/user-email-exists`);
      const response = await axiosInstance.post(`${apiUrl}/users/user-email-exists`, {
        email,
        database,
        User
      });
      
      if (response.status === 200) {
        const doc = {status:"EMAIL FOUND", emailExists: response?.data?.emailExists, passwordExists: response?.data?.passwordExists}
        setEmailExists(doc);
        setLoginError(undefined);
      } else {
        setLoginError("Unexpected response from server");
      }
    } catch (error) {
      console.log("Email check error:", error);
      if (error.code === 'ECONNABORTED') {
        setLoginError("Request timed out. Please check your connection and try again.");
      } else if (!error.response) {
        setLoginError("Network error. Please check your connection and try again.");
      } else {
        setLoginError(error?.response?.data?.error || "An error occurred while checking email");
      }
      setEmailExists({status: "ERROR"});
    }
  }
  if(email) { 
    request()
  }
}

const sendOtp = async (email) => {
  const request = async (req, res) => {
    try {
      const response = await axiosInstance.post(`${apiUrl}/users/send-otp`, {
        email
      });
      if (response.status === 200) {
        setOtpSent(true);
        setLoginError(undefined);
      } 
    } catch (error) {
      console.log("OTP send error:", error);
      if (error.code === 'ECONNABORTED') {
        setLoginError("Request timed out. Please try again.");
      } else if (!error.response) {
        setLoginError("Network error. Please check your connection and try again.");
      } else {
        setLoginError(error?.response?.data?.error || "Error sending OTP");
      }
    }
  }
  request()
}

const returnOtp = async (email, otp) => {
  const request = async (req, res) => {
    console.log("OTP RETURN START ")
    try {
      const response = await axiosInstance.post(`${apiUrl}/users/return-otp`, {
        email,
        otp
      });
      if (response.status === 200) {
        const data = response.data
        const doc = {email: data?.email, token: data?.token, passwordExists: data?.passwordExists}
        localStorage.setItem('user', JSON.stringify(doc))
        setSUser(data?.sUser)
        setCustomer(data?.customer)
        dispatch({type: 'LOGIN', payload: doc})
        setLoginError(undefined);
      } 
    } catch (error) {
      console.log("OTP return error:", error);
      if (error.code === 'ECONNABORTED') {
        setLoginError("Request timed out. Please try again.");
      } else if (!error.response) {
        setLoginError("Network error. Please check your connection and try again.");
      } else {
        setLoginError(error?.response?.data?.error || "Error verifying OTP");
      }
    }
  }
  if(email && otp) {
    request()
  }
}

const login = async (email, password) => {
  const request = async (req, res) => {
    try {
      const response = await axiosInstance.post(`${apiUrl}/users/login`, {
        email,
        password
      });
      if (response.status === 200) {
        const data = response.data
        const doc = {email: data?.email, token: data?.token, passwordExists: data?.passwordExists}
        localStorage.setItem('user', JSON.stringify(doc))
        setSUser(data?.sUser)
        setCustomer(data?.customer)
        dispatch({type: 'LOGIN', payload: doc})
        setLoginError(undefined);
      } 
    } catch (error) {
      console.log("Login error:", error);
      if (error.code === 'ECONNABORTED') {
        setLoginError("Request timed out. Please try again.");
      } else if (!error.response) {
        setLoginError("Network error. Please check your connection and try again.");
      } else {
        setLoginError(error?.response?.data?.error || "Error during login");
      }
    }
  }
  if(email && password) {
    request()
  }
}

  const background = !transparentBackground ? {} : {background:"rgba(0,0,0,0)"}
  const testFunction = () => {
    const testPost = async () => {
      try {
        // Log environment info
        console.log("TEST ENV PROD", process.env.NODE_ENV, apiUrl);
        
        // Log device info
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        console.log("User Agent:", userAgent);
        console.log("Platform:", platform);
        
        // Get current origin
        const origin = window.location.origin;
        console.log("Current Origin:", origin);
        
        // Ensure HTTPS for production URLs
        const url = apiUrl.includes('beta-api.relyonfm.com') 
          ? apiUrl.replace('http://', 'https://') 
          : apiUrl;
          
        console.log("STARTING POST", `${url}/tests/testPost`);
        
        const response = await axiosInstance.post(`${url}tests/testPost`, {
          testMessage: "TEST MESSAGE",
          deviceInfo: {
            userAgent,
            platform,
            isMobile: /iPhone|iPad|iPod|Android/i.test(userAgent),
            origin
          }
        });

        console.log("RESPONSE:", response.data);
      } catch (error) {
        console.log("Test error details:", {
          name: error.name,
          message: error.message,
          stack: error.stack
        });
        
        if (error.code === 'ECONNABORTED') {
          console.log("Request timeout error");
          setLoginError("Request timed out. Please try again.");
        } else if (!error.response) {
          console.log("Network error - possibly CORS or connection issue");
          setLoginError("Network error. Please check your connection and try again.");
        } else {
          setLoginError(`Test request failed: ${error.response?.data?.error || error.message}`);
        }
      }
    }
    testPost() 
  }

  const handlePasswordKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      login(email, password);
    }
  };

  const handleOtpKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      returnOtp(email, otp);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent form submission
    login(email, password);
  };

  return (
    <form 
      style={{...background}} 
      className="login" 
      autoComplete="on"
      onSubmit={handleSubmit}
      id="login-form"
      name="login-form"
    >
      {/* <button type="button" onClick={testFunction}>TestLoginOk</button>  */}
      <label style={{color: labels?.color}} htmlFor="email">{labels.email}</label>

      <input 
        style={{...background, fontSize:"16px", color: labels?.color}}  
        type="email" 
        id="email"
        name="email"
        autoComplete="email"
        onChange={(e) => {
          setEmail(e.target.value)
          setEmailExists({status:"CHECKING"})
          setLoginError(undefined)
        }} 
        onBlur={(e) => emailExistsFn(e.target.value, database)} 
        onKeyDown={(e) => {
          if (e.key === 'Enter'  || e.key === ' ') {
            emailExistsFn(e.target.value, database)
          }
        }}
        value={email} 
      />
      <VisDiv rules={[emailExists?.status == "EMAIL FOUND"]}>
        <VisDiv rules={[emailExists?.passwordExists]}>
          <label style={{color: labels?.color}} htmlFor="password">{labels.password}</label>
          <input 
            style={{...background, fontSize:"16px", color: labels?.color}}  
            type="password"
            id="password"
            name="password"
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)} 
            onKeyDown={handlePasswordKeyDown}
            value={password} 
          />
        </VisDiv>
        <VisDiv rules={[emailExists?.passwordExists]}>  
          <button type="submit" className={buttonClassName ? buttonClassName : "library-login-button"} style={{color: labels?.color, marginBottom:"20px"}} disabled={false}>LOG IN</button>
        </VisDiv>
        <VisDiv rules={[emailExists?.passwordExists, !otpSent]}>
          <label style={{color: labels?.color}}>OPPURE</label>
        </VisDiv>
        <VisDiv rules={[otpSent]}>
          <label style={{color: labels?.color}}>{"INSERISCI IL CODICE RICEVUTO VIA EMAIL"}</label>
          <input 
            style={{...background, fontSize:"16px", color: labels?.color}}  
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
            onChange={(e) => setOtp(e.target.value)} 
            onKeyDown={handleOtpKeyDown}
            value={otp} 
          />
        <button type="button" onClick={()=>returnOtp(email,otp)} className={buttonClassName ? buttonClassName : "library-login-button"} style={{color: labels?.color, marginTop:"20px"}} >INVIA CODICE</button>
        </VisDiv>
          <button type="button" onClick={()=>sendOtp(email)} className={buttonClassName ? buttonClassName : "library-login-button"} style={{color: labels?.color, marginTop:"20px"}} disabled={false}>RICHIEDI CODICE</button>
      </VisDiv>
      <VisDiv rules={[loginError]}>
        {<div style={{...background}} className="error">{loginError}</div>}
      </VisDiv>
    </form>
  )
}

export default LoginForm
